import React, {useState} from 'react';
import {
    Box,
    Button,
    CssBaseline,
    TextField,
    Typography,
    Dialog,
    DialogContent,
    Grid
} from '@mui/material';
import {Link, useNavigate} from 'react-router-dom';
import AuthService from '../../services/auth.service';
import {dropdownItems} from "../../views/dropdownItems";
import VOCSETLayout from "../../views/VOCSETLayout";

interface ChangePasswordProps {
    onSuccess: () => void;
}

const ChangePassword: React.FC<ChangePasswordProps> = ({onSuccess}) => {
    const [currentPassword, setCurrentPassword] = useState<string>('');
    const [newPassword, setNewPassword] = useState<string>('');
    const [confirmNewPassword, setConfirmNewPassword] = useState<string>('');
    const [passwordError, setPasswordError] = useState<string>('');
    const navigate = useNavigate();
    const username = localStorage.getItem('currentUser');
    const [openDialog, setOpenDialog] = useState(false);
    const [error, setError] = useState('');

    const handleSave = async () => {

        if (newPassword !== confirmNewPassword) {
            setPasswordError('Passwords do not match');
            return;
        } else {
            setPasswordError('');
        }

        try {
            await AuthService.changePassword(username, currentPassword, newPassword);
            onSuccess();
            handleOpenDialog();
            setTimeout(() => {
                handleCloseDialog();
            }, 2000);
        } catch (error) {
            // @ts-ignore
            setError(error?.response?.data?.result?.[0]?.message || 'Error updating password. Please try again.');
        }
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        navigate('/UserDashboard')
    };

    let dialogContent = 'Update complete';

    return (
        <div>
            <VOCSETLayout dropdownItems={dropdownItems}>
                <CssBaseline/>
                <Box
                    sx={{
                        marginTop: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start'
                    }}
                >
                    <Typography component="h1" variant="h5" sx={{alignSelf: 'flex-start'}}>
                        Change Password
                    </Typography>
                    <Box component="form" noValidate sx={{mt: 3, width: '100%'}}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="currentPassword"
                                    label="Current Password"
                                    name="currentPassword"
                                    type="password"
                                    value={currentPassword}
                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="newPassword"
                                    label="New Password"
                                    name="newPassword"
                                    type="password"
                                    value={newPassword}
                                    error={passwordError !== ''}
                                    helperText={passwordError}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="confirmPassword"
                                    label="Confirm New Password"
                                    name="confirmPassword"
                                    type="password"
                                    value={confirmNewPassword}
                                    error={passwordError !== ''}
                                    helperText={passwordError}
                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                onClick={handleSave}
                                variant="contained"
                                sx={{width: 'auto', mb: 2}}
                            >
                                Save
                            </Button>
                            <Button
                                component={Link}
                                to="/TradeDashboard"
                                variant="contained"
                                color="secondary"
                                sx={{width: 'auto', mb: 2, marginLeft: 3, bgcolor: 'red', '&:hover': {bgcolor: 'red'}}}
                            >
                                Cancel
                            </Button>
                        </Grid>
                    </Box>
                    {error && (
                        <Typography variant="body2" color="error" align="center">
                            {error}
                        </Typography>
                    )}
                </Box>
            </VOCSETLayout>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogContent>
                    <Typography variant="body1">{dialogContent}</Typography>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ChangePassword;
